import React from "react";
import { Navigate } from "react-router-dom";

import {
  PartDetailsPage,
  ContactPage,
  WorkOrderDetails,
  DisplaysPage,
  LaborPage,
  LaborDetailsPage,
  TicketsPage,
  OrganizationSettings,
  ModelsPage,
  ShippingPage,
  BarcodeBuilder,
  ShipmentBuilderPage,
  SchedulePage,
  ResetPasswordPage,
  WorkOrdersPage,
  ReportsPage,
  BarcodeBatchEditor,
  SalesPage,
  DashboardPage,
  UserProfilePage,
} from "./pages";
import SignIn from "./pages/SignIn/SignIn";
import OrderPage from "./pages/Order/OrderPage";
import { QuoteBuilderPage } from "./pages/QuoteBuilderPage";
import {
  NotificationsPage,
  NotificationPreferencesRedirect,
} from "./pages/Notifications";

const authenticate = true;

export const routes = [
  {
    path: "/",
    element: <Navigate to="/signin" />,
  },
  {
    path: "/signin",
    title: "Foundry Sign In",
    element: <SignIn />,
  },
  {
    path: "/signup",
    title: "Foundry Sign Up",
    // element: <SignIn signUp />,
    element: <Navigate to="/signin" />,
  },
  {
    path: "/reset",
    title: "Reset Password",
    element: <ResetPasswordPage />,
  },
  {
    path: "/dashboard",
    title: "Dashboard",
    element: <DashboardPage />,
    authenticate,
  },
  {
    path: "/customers/:id",
    title: "Customer Contact",
    element: <ContactPage />,
    authenticate,
  },
  {
    path: "/parts",
    title: "Foundry Group Parts",
    element: <Navigate to="/models?view=2" />,
    authenticate,
  },
  {
    path: "/parts/:id",
    title: "Part Details",
    element: <PartDetailsPage />,
    authenticate,
  },
  {
    path: "/users/:userId",
    title: "User Profile",
    element: <UserProfilePage />,
    authenticate,
  },
  {
    path: "/reports",
    title: "Reports",
    element: <ReportsPage />,
    authenticate,
  },
  {
    path: "/works",
    title: "Foundry Work Orders",
    // element: <Navigate to="/models?view=4" />,
    element: <WorkOrdersPage />,
    authenticate,
  },
  {
    path: "/works/:id",
    title: "Work Order Details",
    element: <WorkOrderDetails />,
    useTitleId: true,
    authenticate,
  },
  {
    path: "/orders",
    title: "Purchase Orders",
    // element: <OrdersPage />,
    element: <Navigate to="/models?view=3" />,
    authenticate,
  },
  {
    path: "/orders/:id",
    title: "View Order",
    element: <OrderPage />,
    authenticate,
  },
  {
    path: "/quotes",
    title: "View Quote",
    element: <QuoteBuilderPage />,
    authenticate,
  },
  {
    path: "/quotes/:id",
    title: "View Quote",
    element: <QuoteBuilderPage />,
    authenticate,
  },
  {
    path: "/displays",
    title: "Displays",
    element: <DisplaysPage />,
    authenticate,
  },
  {
    path: "/models",
    title: "Models",
    element: <ModelsPage />,
    authenticate,
  },
  {
    path: "/organization",
    title: "Organization Settings",
    element: <OrganizationSettings />,
    authenticate,
  },
  {
    path: "/notifications",
    title: "Notifications",
    element: <NotificationsPage />,
    authenticate,
  },
  {
    path: "/notifications/preferences",
    title: "Notification Preferences",
    element: <NotificationPreferencesRedirect />,
    authenticate,
  },
  {
    path: "/settings",
    title: "User Settings",
    element: <></>,
    authenticate,
  },
  {
    path: "/labor",
    title: "Work Order Labor",
    element: <LaborPage />,
    authenticate,
  },
  {
    path: "/tickets",
    title: "Labor Tickets",
    element: <TicketsPage />,
    authenticate,
  },
  {
    path: "/labor/:id",
    title: "Work Order Labor",
    element: <LaborDetailsPage />,
    authenticate,
  },
  {
    path: "/outbound",
    title: "Outbound Shipping",
    element: <ShippingPage />,
    authenticate,
  },
  {
    path: "/shipping/:id",
    title: "Shipment Order",
    element: <ShipmentBuilderPage />,
    authenticate,
  },
  {
    path: "/barcodes/batch/:id",
    title: "Barcodes",
    element: <BarcodeBatchEditor batch />,
    authenticate,
  },
  {
    path: "/barcodes/:id",
    title: "Barcodes",
    element: <BarcodeBuilder />,
    authenticate,
  },
  {
    path: "/schedule",
    title: "Schedule",
    element: <SchedulePage />,
    authenticate,
  },
  {
    path: "/sales",
    title: "Sales",
    element: <SalesPage />,
    authenticate,
  },
  {
    path: "/not-found",
    element: <Navigate to="/customers" />,
  },
  {
    path: "*",
    element: <Navigate to="/not-found" />,
  },
];
export default routes;
